import React, { useEffect, useState, useMemo } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { colors } from "@mui/material";

function ClientQuality() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const {setGlobalLoading, token } = useOutletContext();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [groupBreakup, setGroupBreakup] = useState([]);
 
  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  
  const [selectedYear, setSelectedYear] = useState(currentFY);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_client_quality/`,
        {
            params: { year: selectedYear },
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setOptions(response.data.client_quality || []);
        
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

  useEffect(() => {
    if (token && selectedYear) {
        fetchOptions();
    }
  }, [token, selectedYear]); 


  const financialYears = Array.from({ length: 5 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  }); 

    const fetchCompanyVobt = async (companyId, financialYear) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/reports/company_revenue_details/${companyId}`,
                {
                    params: {
                        financial_year: financialYear,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setGroupBreakup(response.data.vobt_breakup || []);
        } catch (error) {
            console.error(error);
        }
    };
    const handleCompanyClick = (company) => {
        setSelectedCompany(company);
        setShowModal(true);
        fetchCompanyVobt(company.id, selectedYear);
    };

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 700px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 150px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 150px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          } 
        .client-column {
            width: 70%;
            white-space: normal !important;
            word-break: break-word;
            }

        .amount-column {
            width: 30%;
            white-space: nowrap;
            } 
        .sticky-summary td {
            position: sticky;
            top: 22px;      /* Height of the header */
            background: #e9ecef;
            z-index: 20;
            font-weight: bold;
        }      
        `}
        </style>  
        <div className={`modal fade ${showModal ? "show d-block" : ""}`} tabIndex="-1" style={{backgroundColor: "rgba(0,0,0,0.5)",}}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">

                <div className="modal-header">
                    <h5 className="modal-title">
                    Clousre Details
                    {selectedCompany && (
                        <> - {selectedCompany.client_name}</>
                    )}
                    </h5>

                    <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                    />
                </div>

                <div className="modal-body">
                    {selectedCompany && (
                        <>
                         <table className="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>Role</th>
                                    <th>Candidate</th>
                                    <th className="text-end">VoBT</th>
                                    <th className="text-end">Billable Comp</th>
                                    <th className="text-end">Total Fee</th>
                                    <th className="text-end">Fee %</th>
                                    <th className="text-end">Fee % (VoBT)</th>
                                    <th className="text-end">ARPA</th>
                                </tr>
                            </thead>

                            <tbody>
                                {groupBreakup.length > 0 ? (
                                    groupBreakup.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.role_name}</td>
                                            <td>{item.candidate}</td>
                                            <td className="text-end">{formatNumber(item.VoBT)}</td>
                                            <td className="text-end">{formatNumber(item.billedComp)}</td>
                                            <td className="text-end">{formatNumber(item.totalFee)}</td>
                                            <td className="text-end">{item.averageFeePercent}</td>
                                            <td className="text-end">{item.averageFeeVOBT}</td>
                                            <td className="text-end">{formatNumber(item.ARPA)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No Closed Roles
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        </>
                    )}
                </div>
                </div>
            </div>
        </div>   
        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-0">
                    Client VOBT Analysis ({selectedYear})
                </h5>
                <div style={{ width: "150px" }}>
                    <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    >
                    {financialYears.map((fy) => (
                        <option key={fy.value} value={fy.value}>
                        {fy.label}
                        </option>
                    ))}
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-xl-12 col-xxl-12">
                    <div className="table-responsive" style={{ maxHeight: "1000px" }}>
                    <table className="table table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                            <th className="sticky-col-1">Client</th>
                            <th className="sticky-col-2 text-end">Revenue</th>
                            <th className="text-end">Closure</th>
                            <th className="text-end">VoBT</th>
                            <th className="text-end">Billable Comp</th>
                            <th className="text-end">Total Fee</th>
                            <th className="text-end">Avg VoBT</th>
                            <th className="text-end">Avg Fee(%)</th>
                            <th className="text-end">Avg Fee(VoBT)</th>
                            <th className="text-end">ARPA</th>
                            <th>Sector</th>
                            <th>Business Generated</th>
                            </tr>
                        </thead>

                        <tbody>
                            {options.length > 0 ? (
                            options.map((item, index) => (
                            <tr key={index}>
                                <td className="sticky-col-1">
                                    <a href="#" className="text-decoration-none fw-semibold"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleCompanyClick(item);
                                        }}
                                        >
                                    {item.client_name}        
                                    </a>
                                </td>
                                <td className="sticky-col-2 text-end">{formatNumber(item.revenue)}</td>
                                <td className="text-end">{item.closure}</td>
                                <td className="text-end">{formatNumber(item.VoBT)}</td>
                                <td className="text-end">{formatNumber(item.billedComp)}</td>
                                <td className="text-end">{formatNumber(item.totalFee)}</td>
                                <td className="text-end">{formatNumber(item.averageVoBT)}</td>
                                <td className="text-end">{item.averageFeePercent}</td>
                                <td className="text-end">{item.averageFeeVOBT}</td>
                                <td className="text-end">{formatNumber(item.ARPA)}</td>
                                <td className="">{item.sector}</td>
                                <td className="">{item.businessDeveloper}</td>
                            </tr>
                            ))
                            ) : (
                            <tr>
                                <td colSpan="12" className="text-center">
                                No Data Found
                                </td>
                            </tr>
                            )}
                        </tbody>
                        </table>
                    </div>        
                </div>
            </div>

        </div>
        </div>

        </>
    );
}

export default ClientQuality;